module.exports = __webpack_public_path__ + "img/Icon_Mail.e34293ad.svg";